export default __webpack_public_path__ + "static/media/dash-cb.1c7cf19a.svg";